import { projectRequest } from 'store/utils/request';

export const checkContextNameRequest = (name, exception) =>
  projectRequest.get(`/contexts/`, {
    params: Object.assign(
      {
        name__iexact: name,
      },
      exception
        ? {
            id__not__in: exception,
          }
        : null,
    ),
  });

export const getContextsRequest = async params => {
  try {
    return await projectRequest.get(`/contexts/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addContextRequest = async data => {
  try {
    return await projectRequest.post(`/contexts/`, data);
  } catch (error) {
    throw error;
  }
};

export const getContextRequest = async contextId => {
  try {
    return await projectRequest.get(`/contexts/${contextId}/`);
  } catch (error) {
    throw error;
  }
};

export const updateContextRequest = async (contextId, data) => {
  try {
    return await projectRequest.put(`/contexts/${contextId}/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteContextRequest = async contextId => {
  try {
    return await projectRequest.delete(`/contexts/${contextId}/`);
  } catch (error) {
    throw error;
  }
};
